import { render, staticRenderFns } from "./AttTypeBatchModify.vue?vue&type=template&id=99160f60&scoped=true&"
import script from "./AttTypeBatchModify.vue?vue&type=script&lang=js&"
export * from "./AttTypeBatchModify.vue?vue&type=script&lang=js&"
import style0 from "./AttTypeBatchModify.vue?vue&type=style&index=0&id=99160f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99160f60",
  null
  
)

export default component.exports